import { render, staticRenderFns } from "./CrearNoticia.vue?vue&type=template&id=e1fd661e&"
import script from "./CrearNoticia.vue?vue&type=script&lang=js&"
export * from "./CrearNoticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports